module.exports = __webpack_public_path__ + "common/icon-link-cbce18d86aec82f0fb529309f0ed92f8.svg";